import { Redirect } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { FullVisitPanel } from './FullVisitPanel';
import { VisitPanelLoader } from './VisitPanel.loader';
import { documentationScopeVisitor } from './VisitPanel.utils';

export const VisitPanel = (): JSX.Element => {
   const { visitId } = visitPaths.useVisitParams();

   return (
      <VisitPanelLoader visitId={visitId}>
         {({ visit }) =>
            documentationScopeVisitor(visit.documentationScope)({
               full: () => <FullVisitPanel visit={visit} />,
               prescriptionOnly: () => (
                  <Redirect path={visitPaths.getPrescriptionVisitPath({ params: { visitId: visit.id } })} />
               ),
            })
         }
      </VisitPanelLoader>
   );
};
